import React, { useState, useContext } from 'react'
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent, SidebarFooter } from 'react-pro-sidebar'
import './sidebar.styles.scss'
import { Link, Navigate } from 'react-router-dom';
import { ROUTES } from '../../utils/AppConstants'
import {
    FaSignOutAlt, FaUserAlt, FaPercent, FaBook, FaReceipt, FaFileInvoiceDollar, FaUserCircle,
    FaMoneyCheckAlt, FaDonate
} from "react-icons/fa";
import { useSelector, useDispatch } from 'react-redux';
import { APP_CONSTANTS } from '../../utils/AppConstants'
import { clearLocalStorage, isLoggedInUserCustomer, isLoggedInUserOperator, isLoggedInUserAdmin, isLoggedInUserBusiness } from '../../utils/Utils';

const CustomSidebar = props => {
    const [isCollapsed, setCollapsed] = useState(true)
    const { isLogin, user } = useSelector((state) => state.user)
    const dispatch = useDispatch()

    return (
        <ProSidebar
            collapsed={isCollapsed}
        // toggled={false}
        // breakPoint="md"
        >
            <SidebarHeader>
                <div className='headerContainer' >
                    <div className='toggle-container'>
                        <div className='toggle' onClick={() => {
                            setCollapsed(!isCollapsed)
                        }}>
                            {isCollapsed ?
                                (<div>
                                    <img className='img' src={require('../../assets/hamburger_icon.png')} />
                                </div>) :
                                (<div>
                                    <img className='img' src={require('../../assets/hamburger_back.png')} />
                                </div>)}
                        </div>
                    </div>
                    <div className='logo-container'>
                        {isCollapsed === false ? (<div className='img-container'>
                            <img className='img' src={require('../../assets/logo_ems.png')} />
                        </div>) : (
                            <div className='img-container-collapse'>
                                <img className='img' src={require('../../assets/logo_small.png')} />
                            </div>
                        )}
                    </div>
                </div>
            </SidebarHeader>
            {isLogin && (<SidebarContent>
                <Menu iconShape='circle'>
                    {isLoggedInUserAdmin(user) && <MenuItem icon={<FaUserAlt />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.OPERATOR_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.operatorList} />
                    </MenuItem>}
                    {(isLoggedInUserBusiness(user) || isLoggedInUserCustomer(user)) && <MenuItem icon={<FaPercent />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.OFFER_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.offerList} />
                    </MenuItem>}
                    {isLoggedInUserBusiness(user) && <MenuItem icon={<FaFileInvoiceDollar />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.CASHBACK_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.addCustomerCashback} />
                    </MenuItem>}
                    {isLoggedInUserBusiness(user) && <MenuItem icon={<FaDonate />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.CUSTOMER_CASHBACK_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.vendorCashbackList} />
                    </MenuItem>}
                    {/* {!isLoggedInUserAdmin(user) && <MenuItem icon={<FaReceipt />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.RECEIPT_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.receiptList} />
                    </MenuItem>} */}
                    {(isLoggedInUserBusiness(user) || isLoggedInUserOperator(user)) && <MenuItem icon={<FaBook />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.INVOICE_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.invoiceList} />
                    </MenuItem>}
                    {isLoggedInUserCustomer(user) && <MenuItem icon={<FaMoneyCheckAlt />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.CUSTOMER_CASHBACK_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.customerCashbackList} />
                    </MenuItem>}
                    {(isLoggedInUserOperator(user) || isLoggedInUserCustomer(user)) && <MenuItem icon={<FaFileInvoiceDollar />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.CASHBACK_LIST}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.cashbackRequestList} />
                    </MenuItem>}
                    {isLoggedInUserCustomer(user) && <MenuItem icon={<FaUserCircle />}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.PROFILE}
                        </div>
                        <Link style={{ backgroundColor: 'transparent' }} to={ROUTES.customerProfile} />
                    </MenuItem>}
                    <MenuItem icon={<FaSignOutAlt />} onClick={() => {
                        clearLocalStorage()
                        dispatch({ type: APP_CONSTANTS.LOGOUT })
                    }}>
                        <div style={{ color: '#382f1e', fontSize: 15, fontWeight: '600' }} onClick={() => {
                            clearLocalStorage()
                            dispatch({ type: APP_CONSTANTS.LOGOUT })
                        }}>
                            {APP_CONSTANTS.MENU_ITEM_DISPLAY_NAME.LOGOUT}
                        </div>
                    </MenuItem>
                </Menu>
            </SidebarContent>)}
            <SidebarFooter
                style={{ textAlign: 'center' }}>
                <div
                    className="sidebar-btn-wrapper"
                    style={{
                        padding: '10px 10px',
                    }}
                >
                    <span className='footer-text'>&#169; Copyright {new Date().getFullYear()}</span>
                </div>
            </SidebarFooter>
        </ProSidebar>
    )
}

export default CustomSidebar